export function buttonActionFunc() {
  let menuBtn = $('#jsMenu');
  let posGlobalMenue = $('.posGlobalMenue')
  menuBtn.on('click', function () {
    $(this).toggleClass('active');
    posGlobalMenue.toggleClass('open');
  });
  //blog
  let qaBtn = $('#jsTax');
  qaBtn.find('.taxBox p').on('click', function () {
    $(this).toggleClass('open').next().slideToggle();
  });
}